<template>
  <div class="user-selector">
    <div class="p-2" style="width: 100%; max-width: 400px; display: flex;">
      <!-- TODO: Bug: beim ersten öffnen muss mal 2x clicken -->
      <el-autocomplete
        :size="size"
        style="width: 100%;"
        v-model="membersSearchInput"
        :fetch-suggestions="querySearchAsync"
        placeholder="Please search for user by email"
        @select="onUserHandleSelect">
        <template slot-scope="{ item }">
          <div style="padding: 5px 0; line-height: 1.4em;">
            {{ item.displayName }}<br />
            <img
              style="margin-right: 4px; border-radius: 100%;"
              :src="item.profilePic"
              width="16"
              height="16" />
            <span style="font-size: 9pt">{{ item.value }}</span>
          </div>
        </template>
      </el-autocomplete>
      <!-- <el-button :size="size" type="success">ok</el-button> -->
      <!--
      <el-button
        :size="size"
        class="ml-2"
        type="danger"
        @click="onClickCancel">
        Cancel
      </el-button>
      -->
    </div>
  </div>
</template>

<script>
// import { mapActions } from "vuex";

// TODO: Muss angepasst werden oder komplett ersrzt

// TODO: Avoid displaying sensitive information aka. email addresses her
// TODO: Use username instead

export default {
  props: {
    size: {
      default: 'normal'
    }
  },
  data: () => ({
    membersSearchInput: '',
  }),
  methods: {
    querySearchAsync(queryString, cb) {
      // console.log("queryString", queryString);

      this.$api.contact_query_by_string(queryString).then(cb);
    },

    onUserHandleSelect(selection) {
      console.log("user-selector: onUserHandleSelect", selection);
      /* TODO: Hier wird user direkt hinzugefügt. Allerdings wird das Dokument
      erst bei save gespeichert. Das führt ggf. zu Verwirrungen. */

      if ( selection === 'No match' ) { return };

      this.membersSearchInput = '';

      /* If user has no name yet use email instead */
      if ( !selection.displayName || selection.displayName === 'N/A' ) {
        selection.displayName = selection.email;
      }

      this.$emit('select', selection)
    },

    onClickCancel() {
      this.$emit('cancel')
    }
  },
}
</script>
